import React from 'react';
import { useTranslation } from 'react-i18next';
import { StarFilled } from '@ant-design/icons';

const TitleForTable = (props) => {
	const { i18n } = useTranslation();
	const { model } = props;

	return (
		<div>
			<span>
				{model.displayTitle[i18n.language]}{' '}
				{!!model.isFavorite && <StarFilled style={{ fontSize: '17px', position: 'relative', marginLeft: '5px' }} />}
			</span>
		</div>
	);
};

export default TitleForTable;
